/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateLocalAccountRequest
 */
export interface ValidateLocalAccountRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateLocalAccountRequest
     */
    email?: string | null;
}

/**
 * Check if a given object implements the ValidateLocalAccountRequest interface.
 */
export function instanceOfValidateLocalAccountRequest(value: object): value is ValidateLocalAccountRequest {
    return true;
}

export function ValidateLocalAccountRequestFromJSON(json: any): ValidateLocalAccountRequest {
    return ValidateLocalAccountRequestFromJSONTyped(json, false);
}

export function ValidateLocalAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateLocalAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function ValidateLocalAccountRequestToJSON(json: any): ValidateLocalAccountRequest {
    return ValidateLocalAccountRequestToJSONTyped(json, false);
}

export function ValidateLocalAccountRequestToJSONTyped(value?: ValidateLocalAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

